module.exports = {
  label: {
    enterOtp: 'Enter OTP',
    enterOtpError: 'Please enter otp',
    OtpExpired: 'Your OTP is expired. Please re-send OTP and login again.',
    wrongOTP: 'You have entered wrong OTP.',
    resendOtp: 'Resend OTP',
    wrongOtp:'You have entered wrong OTP',
    buttons: {
      verifyOtp: 'Verify OTP'
    }
  }
};